export default "__VITE_ASSET__a4115f98__"